import { render, staticRenderFns } from "./clipper-preview.vue?vue&type=template&id=4e4fd9af&scoped=true&"
import script from "./clipper-preview.vue?vue&type=script&lang=js&"
export * from "./clipper-preview.vue?vue&type=script&lang=js&"
import style0 from "./clipper-preview.vue?vue&type=style&index=0&id=4e4fd9af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4fd9af",
  null
  
)

export default component.exports